import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { Guid, Visibility } from 'tessa/platform';
import { CdCardTypes } from '../Helpers/CdCardTypes';

export class CdHideTaskHistoryUIExtension extends CardUIExtension {
  public initialized(context: ICardUIExtensionContext) {
    if (!(
            Guid.equals(context.model.card.typeId, CdCardTypes.PkProtocolTenderTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.ArActTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkAssignmentTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkLetterCreditTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkMemoTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.RdndTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkOutgoingTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkIncomingTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.TechnicalDocumentationTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkWorkOrderTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkExecutiveDocumentationTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkExecutiveSchemeTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkDevelopmentScenarionTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkInternalDocumentationTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkProtocolTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.PkPacketVirtualTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.ArEDocumentTypeID) ||
            Guid.equals(context.model.card.typeId, CdCardTypes.InstructionTypeID)
        )) {
      return;
    }

    const taskHistoryForm = context.model.forms.find(x => x.name === '.TaskHistoryViewModel');
    if (!taskHistoryForm) {
      return;
    }
    taskHistoryForm.visibility = Visibility.Collapsed;
  }
}